import { render } from "./RestaurantPage.vue?vue&type=template&id=d2dad602&scoped=true"
import script from "./RestaurantPage.vue?vue&type=script&lang=js"
export * from "./RestaurantPage.vue?vue&type=script&lang=js"

import "./RestaurantPage.vue?vue&type=style&index=0&id=d2dad602&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2dad602"]])

export default __exports__